import { render, staticRenderFns } from "./SelectDisease.vue?vue&type=template&id=dcf6857a&scoped=true"
import script from "./SelectDisease.vue?vue&type=script&lang=js"
export * from "./SelectDisease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf6857a",
  null
  
)

export default component.exports